var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Persist } from "../persist/persist.js";
import { c as commonjsGlobal, g as getDefaultExportFromCjs } from "../_commonjsHelpers-7a77ea84.js";
import "../global-33d5eebf.js";
var toastify$1 = { exports: {} };
/*!
 * Toastify js 1.12.0
 * https://github.com/apvarun/toastify-js
 * @license MIT licensed
 *
 * Copyright (C) 2018 Varun A P
 */
(function(module) {
  (function(root, factory) {
    if (module.exports) {
      module.exports = factory();
    } else {
      root.Toastify = factory();
    }
  })(commonjsGlobal, function(global) {
    var Toastify2 = function(options) {
      return new Toastify2.lib.init(options);
    }, version = "1.12.0";
    Toastify2.defaults = {
      oldestFirst: true,
      text: "Toastify is awesome!",
      node: void 0,
      duration: 3e3,
      selector: void 0,
      callback: function() {
      },
      destination: void 0,
      newWindow: false,
      close: false,
      gravity: "toastify-top",
      positionLeft: false,
      position: "",
      backgroundColor: "",
      avatar: "",
      className: "",
      stopOnFocus: true,
      onClick: function() {
      },
      offset: { x: 0, y: 0 },
      escapeMarkup: true,
      ariaLive: "polite",
      style: { background: "" }
    };
    Toastify2.lib = Toastify2.prototype = {
      toastify: version,
      constructor: Toastify2,
      // Initializing the object with required parameters
      init: function(options) {
        if (!options) {
          options = {};
        }
        this.options = {};
        this.toastElement = null;
        this.options.text = options.text || Toastify2.defaults.text;
        this.options.node = options.node || Toastify2.defaults.node;
        this.options.duration = options.duration === 0 ? 0 : options.duration || Toastify2.defaults.duration;
        this.options.selector = options.selector || Toastify2.defaults.selector;
        this.options.callback = options.callback || Toastify2.defaults.callback;
        this.options.destination = options.destination || Toastify2.defaults.destination;
        this.options.newWindow = options.newWindow || Toastify2.defaults.newWindow;
        this.options.close = options.close || Toastify2.defaults.close;
        this.options.gravity = options.gravity === "bottom" ? "toastify-bottom" : Toastify2.defaults.gravity;
        this.options.positionLeft = options.positionLeft || Toastify2.defaults.positionLeft;
        this.options.position = options.position || Toastify2.defaults.position;
        this.options.backgroundColor = options.backgroundColor || Toastify2.defaults.backgroundColor;
        this.options.avatar = options.avatar || Toastify2.defaults.avatar;
        this.options.className = options.className || Toastify2.defaults.className;
        this.options.stopOnFocus = options.stopOnFocus === void 0 ? Toastify2.defaults.stopOnFocus : options.stopOnFocus;
        this.options.onClick = options.onClick || Toastify2.defaults.onClick;
        this.options.offset = options.offset || Toastify2.defaults.offset;
        this.options.escapeMarkup = options.escapeMarkup !== void 0 ? options.escapeMarkup : Toastify2.defaults.escapeMarkup;
        this.options.ariaLive = options.ariaLive || Toastify2.defaults.ariaLive;
        this.options.style = options.style || Toastify2.defaults.style;
        if (options.backgroundColor) {
          this.options.style.background = options.backgroundColor;
        }
        return this;
      },
      // Building the DOM element
      buildToast: function() {
        if (!this.options) {
          throw "Toastify is not initialized";
        }
        var divElement = document.createElement("div");
        divElement.className = "toastify on " + this.options.className;
        if (!!this.options.position) {
          divElement.className += " toastify-" + this.options.position;
        } else {
          if (this.options.positionLeft === true) {
            divElement.className += " toastify-left";
            console.warn("Property `positionLeft` will be depreciated in further versions. Please use `position` instead.");
          } else {
            divElement.className += " toastify-right";
          }
        }
        divElement.className += " " + this.options.gravity;
        if (this.options.backgroundColor) {
          console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
        }
        for (var property in this.options.style) {
          divElement.style[property] = this.options.style[property];
        }
        if (this.options.ariaLive) {
          divElement.setAttribute("aria-live", this.options.ariaLive);
        }
        if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE) {
          divElement.appendChild(this.options.node);
        } else {
          if (this.options.escapeMarkup) {
            divElement.innerText = this.options.text;
          } else {
            divElement.innerHTML = this.options.text;
          }
          if (this.options.avatar !== "") {
            var avatarElement = document.createElement("img");
            avatarElement.src = this.options.avatar;
            avatarElement.className = "toastify-avatar";
            if (this.options.position == "left" || this.options.positionLeft === true) {
              divElement.appendChild(avatarElement);
            } else {
              divElement.insertAdjacentElement("afterbegin", avatarElement);
            }
          }
        }
        if (this.options.close === true) {
          var closeElement = document.createElement("button");
          closeElement.type = "button";
          closeElement.setAttribute("aria-label", "Close");
          closeElement.className = "toast-close";
          closeElement.innerHTML = "&#10006;";
          closeElement.addEventListener(
            "click",
            (function(event) {
              event.stopPropagation();
              this.removeElement(this.toastElement);
              window.clearTimeout(this.toastElement.timeOutValue);
            }).bind(this)
          );
          var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
          if ((this.options.position == "left" || this.options.positionLeft === true) && width > 360) {
            divElement.insertAdjacentElement("afterbegin", closeElement);
          } else {
            divElement.appendChild(closeElement);
          }
        }
        if (this.options.stopOnFocus && this.options.duration > 0) {
          var self = this;
          divElement.addEventListener(
            "mouseover",
            function(event) {
              window.clearTimeout(divElement.timeOutValue);
            }
          );
          divElement.addEventListener(
            "mouseleave",
            function() {
              divElement.timeOutValue = window.setTimeout(
                function() {
                  self.removeElement(divElement);
                },
                self.options.duration
              );
            }
          );
        }
        if (typeof this.options.destination !== "undefined") {
          divElement.addEventListener(
            "click",
            (function(event) {
              event.stopPropagation();
              if (this.options.newWindow === true) {
                window.open(this.options.destination, "_blank");
              } else {
                window.location = this.options.destination;
              }
            }).bind(this)
          );
        }
        if (typeof this.options.onClick === "function" && typeof this.options.destination === "undefined") {
          divElement.addEventListener(
            "click",
            (function(event) {
              event.stopPropagation();
              this.options.onClick();
            }).bind(this)
          );
        }
        if (typeof this.options.offset === "object") {
          var x = getAxisOffsetAValue("x", this.options);
          var y = getAxisOffsetAValue("y", this.options);
          var xOffset = this.options.position == "left" ? x : "-" + x;
          var yOffset = this.options.gravity == "toastify-top" ? y : "-" + y;
          divElement.style.transform = "translate(" + xOffset + "," + yOffset + ")";
        }
        return divElement;
      },
      // Displaying the toast
      showToast: function() {
        this.toastElement = this.buildToast();
        var rootElement;
        if (typeof this.options.selector === "string") {
          rootElement = document.getElementById(this.options.selector);
        } else if (this.options.selector instanceof HTMLElement || typeof ShadowRoot !== "undefined" && this.options.selector instanceof ShadowRoot) {
          rootElement = this.options.selector;
        } else {
          rootElement = document.body;
        }
        if (!rootElement) {
          throw "Root element is not defined";
        }
        var elementToInsert = Toastify2.defaults.oldestFirst ? rootElement.firstChild : rootElement.lastChild;
        rootElement.insertBefore(this.toastElement, elementToInsert);
        Toastify2.reposition();
        if (this.options.duration > 0) {
          this.toastElement.timeOutValue = window.setTimeout(
            (function() {
              this.removeElement(this.toastElement);
            }).bind(this),
            this.options.duration
          );
        }
        return this;
      },
      hideToast: function() {
        if (this.toastElement.timeOutValue) {
          clearTimeout(this.toastElement.timeOutValue);
        }
        this.removeElement(this.toastElement);
      },
      // Removing the element from the DOM
      removeElement: function(toastElement) {
        toastElement.className = toastElement.className.replace(" on", "");
        window.setTimeout(
          (function() {
            if (this.options.node && this.options.node.parentNode) {
              this.options.node.parentNode.removeChild(this.options.node);
            }
            if (toastElement.parentNode) {
              toastElement.parentNode.removeChild(toastElement);
            }
            this.options.callback.call(toastElement);
            Toastify2.reposition();
          }).bind(this),
          400
        );
      }
    };
    Toastify2.reposition = function() {
      var topLeftOffsetSize = {
        top: 15,
        bottom: 15
      };
      var topRightOffsetSize = {
        top: 15,
        bottom: 15
      };
      var offsetSize = {
        top: 15,
        bottom: 15
      };
      var allToasts = document.getElementsByClassName("toastify");
      var classUsed;
      for (var i = 0; i < allToasts.length; i++) {
        if (containsClass(allToasts[i], "toastify-top") === true) {
          classUsed = "toastify-top";
        } else {
          classUsed = "toastify-bottom";
        }
        var height = allToasts[i].offsetHeight;
        classUsed = classUsed.substr(9, classUsed.length - 1);
        var offset = 15;
        var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
        if (width <= 360) {
          allToasts[i].style[classUsed] = offsetSize[classUsed] + "px";
          offsetSize[classUsed] += height + offset;
        } else {
          if (containsClass(allToasts[i], "toastify-left") === true) {
            allToasts[i].style[classUsed] = topLeftOffsetSize[classUsed] + "px";
            topLeftOffsetSize[classUsed] += height + offset;
          } else {
            allToasts[i].style[classUsed] = topRightOffsetSize[classUsed] + "px";
            topRightOffsetSize[classUsed] += height + offset;
          }
        }
      }
      return this;
    };
    function getAxisOffsetAValue(axis, options) {
      if (options.offset[axis]) {
        if (isNaN(options.offset[axis])) {
          return options.offset[axis];
        } else {
          return options.offset[axis] + "px";
        }
      }
      return "0px";
    }
    function containsClass(elem, yourClass) {
      if (!elem || typeof yourClass !== "string") {
        return false;
      } else if (elem.className && elem.className.trim().split(/\s+/gi).indexOf(yourClass) > -1) {
        return true;
      } else {
        return false;
      }
    }
    Toastify2.lib.init.prototype = Toastify2.lib;
    return Toastify2;
  });
})(toastify$1);
var toastifyExports = toastify$1.exports;
const Toastify = /* @__PURE__ */ getDefaultExportFromCjs(toastifyExports);
const toastify = "";
class LocalAchievementService {
  constructor() {
    __publicField(this, "achievements", []);
    __publicField(this, "playerStates", {});
    __publicField(this, "isFlushing", false);
    __publicField(this, "flushQueue", []);
    __publicField(this, "autoFlush", 100);
    __publicField(this, "autoFlushCounter", 0);
    __publicField(this, "queuedUpdates", {});
    window.achievementService = this;
  }
  async flush() {
    if (this.isFlushing) {
      return new Promise((resolve) => this.flushQueue.push(resolve));
    }
    this.isFlushing = true;
    const promises = [];
    for (const playerId in this.queuedUpdates) {
      for (let i = 0; i < this.queuedUpdates[playerId].length; i++) {
        const name = this.queuedUpdates[playerId][i];
        promises.push(
          Persist.getInstance().set(`achievement-${playerId}-${name}`, this.playerStates[playerId][name] ?? 0)
        );
      }
    }
    this.queuedUpdates = {};
    await Promise.all(promises);
    while (this.flushQueue.length > 0) {
      const nextFlush = this.flushQueue.shift();
      if (nextFlush) {
        await nextFlush();
      }
    }
    this.autoFlushCounter = 0;
    this.isFlushing = false;
  }
  queueUpdate(playerId, achievement) {
    this.queuedUpdates[playerId] = this.queuedUpdates[playerId] || [];
    if (!this.queuedUpdates[playerId].includes(achievement)) {
      this.queuedUpdates[playerId].push(achievement);
    }
    if (this.autoFlushCounter++ >= this.autoFlush) {
      this.flush();
    }
  }
  registerAchievement(achievement) {
    Persist.getInstance().set(`achievementdata-${achievement.name}`, {
      name: achievement.name,
      description: achievement.description,
      target: achievement.target
    });
    if (!this.achievements.find((a) => a.name === achievement.name)) {
      this.achievements.push({ ...achievement, progress: 0, target: achievement.target });
      for (const playerId in this.playerStates) {
        this.playerStates[playerId][achievement.name] = this.playerStates[playerId][achievement.name] || 0;
      }
    } else {
      const index = this.achievements.findIndex((a) => a.name === achievement.name);
      if (achievement.description && !this.achievements[index].description) {
        this.achievements[index].description = achievement.description;
      }
    }
  }
  async update(playerId) {
    const playerState = this.playerStates[playerId] || {
      ...this.achievements.reduce((acc, a) => {
        acc[a.name] = 0;
        return acc;
      }, {})
    };
    this.playerStates[playerId] = playerState;
    const keys = Object.keys(playerState);
    const dbKeys = await Persist.getInstance().listKeys();
    const achievementsToFetch = dbKeys.filter((key) => key.startsWith("achievementdata-"));
    await Promise.all(
      achievementsToFetch.map(async (key) => {
        const achievement = await Persist.getInstance().get(key);
        if (!this.achievements.find((a) => a.name === achievement.name)) {
          this.registerAchievement(achievement);
        }
      })
    );
    dbKeys.forEach((key) => {
      const [_prefix, _playerId, achievementName] = key.split("-");
      if (_prefix === "achievement" && _playerId === playerId && !keys.includes(achievementName)) {
        keys.push(achievementName);
      }
    });
    await Promise.all(
      keys.map(async (key) => {
        try {
          const progress = await Persist.getInstance().get(`achievement-${playerId}-${key}`);
          this.playerStates[playerId][key] = progress;
        } catch (e) {
          this.playerStates[playerId][key] = 0;
        }
      })
    );
  }
  getAchievements() {
    return this.achievements;
  }
  async unlockAchievement(playerId, name) {
    const achievement = this.achievements.find((a) => a.name === name);
    if (!achievement) {
      return Promise.reject("Achievement not found");
    }
    this.setAchievementProgress(playerId, name, achievement.target);
    await this.flush();
  }
  getUnlockedAchievements(playerId) {
    return Object.keys(this.playerStates[playerId]).filter(
      (key) => {
        var _a;
        return this.playerStates[playerId][key] === ((_a = this.achievements.find((a) => a.name === key)) == null ? void 0 : _a.target);
      }
    );
  }
  getAchievement(playerId, name) {
    const achievement = this.achievements.find((a) => a.name === name);
    if (!achievement) {
      return null;
    }
    return {
      name: achievement.name,
      description: achievement.description,
      progress: this.playerStates[playerId][name] || 0,
      target: achievement.target
    };
  }
  getAchievementProgress(playerId, name) {
    return this.playerStates[playerId][name] || 0;
  }
  setAchievementProgress(playerId, name, progress) {
    const achievement = this.achievements.find((a) => a.name === name);
    if (!achievement) {
      throw new Error("Achievement not found");
    }
    const isCompleteAlready = this.playerStates[playerId][name] >= achievement.target;
    progress = Math.min(progress, achievement.target);
    this.playerStates[playerId][name] = progress;
    this.queueUpdate(playerId, name);
    if (isCompleteAlready) {
      console.log("Already complete", name, progress, achievement.target);
      return true;
    }
    if (progress >= achievement.target) {
      Toastify({
        text: `Achievement unlocked: ${achievement.name}`,
        duration: 3e3,
        gravity: "top",
        position: "right",
        backgroundColor: "green"
      }).showToast();
      this.flush();
      return true;
    }
    return false;
  }
  incrementAchievementProgress(playerId, name, increment) {
    const achievement = this.achievements.find((a) => a.name === name);
    if (!achievement) {
      throw new Error("Achievement not found");
    }
    const progress = (this.playerStates[playerId][name] ?? 0) + increment;
    return this.setAchievementProgress(playerId, name, progress);
  }
  async resetAchievementProgress(playerId, name) {
    this.playerStates[playerId][name] = 0;
    await this.setAchievementProgress(playerId, name, 0);
  }
}
export {
  LocalAchievementService
};
//# sourceMappingURL=LocalAchievementService.js.map
